import { GroundType } from 'models/ground';
import React from 'react';
import { Group, Line } from 'react-konva';
import {
  DEFAULT_PITCH_LINE_COLOR,
  DEFAULT_PITCH_STROKEWIDTH,
} from '../constants';
import Vertices from '../Vertices';
import { GroundGeometry } from '../../../../types/webPlayer';

export default function Fencing(props: { groundData: GroundType; scale: number; vertices: boolean, groundGeometry: GroundGeometry }) {
  const { groundData, vertices, groundGeometry, scale } = props;

  const {dims, vertex} = groundGeometry;
  const {width} = dims;

  const {
    vertexA,
    vertexB,
    vertexC,
    vertexD,
  } = vertex;

  const enGardeOffset = 2 * scale;
  const warningZoneStartOffset = enGardeOffset + 3 * scale;
  const warningZoneEndOffset = warningZoneStartOffset + 2 * scale;

  return (
    <Group>
      {vertices ? <Vertices A={vertexA} C={vertexC} /> : null}
      {/* border */}
      <Line
        fill={groundData.groundSurfaceColor ? groundData.groundSurfaceColor : '#00000000'}
        points={[
          vertexA.x, vertexA.y,
          vertexB.x, vertexB.y,
          vertexC.x, vertexC.y,
          vertexD.x, vertexD.y
        ]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
        closed
      />
      {/* warning zone end */}
      <Line
        points={[vertexA.x + width / 2 - warningZoneEndOffset, vertexA.y, vertexC.x - width / 2 - warningZoneEndOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* warning zone start */}
      <Line
        points={[vertexA.x + width / 2 - warningZoneStartOffset, vertexA.y, vertexC.x - width / 2 - warningZoneStartOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* en-garde */}
      <Line
        points={[vertexA.x + width / 2 - enGardeOffset, vertexA.y, vertexC.x - width / 2 - enGardeOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* center */}
      <Line
        points={[vertexA.x + width / 2, vertexA.y - 0.3 * scale, vertexC.x - width / 2, vertexC.y + 0.3 * scale]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* en-garde */}
      <Line
        points={[vertexA.x + width / 2 + enGardeOffset, vertexA.y, vertexC.x - width / 2 + enGardeOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* warning zone start */}
      <Line
        points={[vertexA.x + width / 2 + warningZoneStartOffset, vertexA.y, vertexC.x - width / 2 + warningZoneStartOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
      {/* warning zone end */}
      <Line
        points={[vertexA.x + width / 2 + warningZoneEndOffset, vertexA.y, vertexC.x - width / 2 + warningZoneEndOffset, vertexC.y]}
        stroke={DEFAULT_PITCH_LINE_COLOR}
        strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
      />
    </Group>
  );
}
